import { useState } from 'react';
import CarouselItem from "MiniSiteComponents/Carousel/Carousel.interface"
import ShowMoreButton from "GeneralComponents/ShowMoreButton";
import CircleCard from './Mobile_CircleCard';
import CollapseContentCard from './Mobile_CollpaseContentCard';
import Consts from "Interfaces/Consts";
import Helper from 'Interfaces/Helper';

interface Props {
    contentShowItems: CarouselItem[];
    componentId: string;
    direction: string;
    componentTitle: string;
    linkTarget?: string;
}

const MobileCircles: React.FC<Props> = ({ componentId, componentTitle, contentShowItems, direction, linkTarget }) => {

    const [isShowMoreItems, setIsShowMoreItems] = useState(false);
    const [activeElementIdx, setActiveElementIdx] = useState('-1');
    const itemsNumClass = (contentShowItems.length >= 4 && !isShowMoreItems) ? 'd-none' : '';
    const itemsToRender = isShowMoreItems ? contentShowItems : contentShowItems.slice(0, 4);

    const toggleShowMoreItems = () => {
        if (!isShowMoreItems) {
            Helper.handleLinkClicksGA4("Circles View", componentTitle, "more items");
        }
        setIsShowMoreItems(prev => !prev);
    }

    const onCardClick = (activeElementIdx: string, itemTitle: string) => {
        setActiveElementIdx(activeElementIdx);
        Helper.handleLinkClicksGA4('Circles View', componentTitle, itemTitle);
    }

    return (

        <>
            {
                itemsToRender.map((contentShowItem, idx) => {

                    const collapseId = componentId + "-collapse-" + contentShowItem.index;

                    return (
                        <div className={`card pb-3 ${idx >= 4 ? itemsNumClass : ''}`} key={idx} >

                            <CircleCard
                                collapseId={collapseId}
                                componentId={componentId}
                                contentShowItem={contentShowItem}
                                isSelected={activeElementIdx == contentShowItem.index}
                                onCardClick={() => onCardClick(contentShowItem.index, contentShowItem.title)}
                                linkTarget={linkTarget}>

                                <CircleCard.Content contentShowItem={contentShowItem} />

                            </CircleCard>

                            <CollapseContentCard
                                collapseId={collapseId}
                                contentShowItem={contentShowItem}
                                componentId={componentId}
                                componentTitle={componentTitle}
                                closeCard={() => setActiveElementIdx('-1')}
                                isSelected={activeElementIdx == contentShowItem.index}
                                linkTarget={linkTarget}
                            />

                        </div>
                    )
                })

            }
            {
                contentShowItems.length > 4 &&
                <div className="text-center">
                    <ShowMoreButton
                        showMore={toggleShowMoreItems}
                        btnClass="btn btn-outline-primary mst-btn px-5 mx-auto my-3 mst-show-more-btn "
                        txtOpen={`${Consts.showMore} (${contentShowItems.length - 4})`}
                        txtClose={Consts.close}
                        isOpen={isShowMoreItems}
                    />
                </div>
            }
        </>
    );
    
}

export default MobileCircles;